export default "__VITE_ASSET__BEwdze8a__"